export enum EDayType {
  Default,
  Holiday,
}
